import { api } from "../api";
import { Table1 } from "../interface";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getTableData(workbook: string, table: string): Promise<Table1[] | null> {
    if (!api.clientApi) {
        return null;
    }

    return api.clientApi.clientWorkbookTableList(store.db ? store.db : "", workbook, table).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
        }
        return (response as unknown as { results?: Table1[] }).results ?? [];
    });
}

export { getTableData };
